import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';

export default mergeStyleSets({
  messageBarBody: {
    display: 'block',
    color: theme.palette.neutralDark,
    fontWeight: 400,
  },
  primaryBottomBorder: {
    backgroundColor: 'transparent',
    borderBottom: `1px solid ${theme.palette.themePrimary}`,
  },
  transparentBackground: {
    backgroundColor: 'transparent',
    ':active': {
      backgroundColor: 'transparent',
    },
    ':hover': {
      backgroundColor: 'transparent',
    },
  },
});
